
import Search from 'vux/src/components/search/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'

import pkHeader from  './header/header.vue'
import station from  './station.vue'
export default {
data() {
return {
cityname: '',
address: [],
serach: "",
datac: [],
title: "选择车站",
data: [],
citynameValue:localStorage.getItem("$currentCity") ? true:false,
jbStorage:JSON.parse(localStorage.getItem('jbStorage'))
}
},
created() {
this.$http.post(window.innerAPI + "?server=queryStationSite", {
"channelCode":localStorage.getItem('useCar_jb_channelCode')
}).then(res => {
this.datac = res.data.data.data
}).catch(err => {

})
if(this.$until.getUrlParam('cityNo')){
this.$http.post(window.innerAPI + "?server=queryStationOpenCity", {
"channelCode":localStorage.getItem('useCar_jb_channelCode')
}).then(res => {
if(res.data.data){
for(var i in res.data.data.data){
if(res.data.data.data[i].cityNo == (this.$until.getUrlParam("cityNo")||localStorage.getItem("$currentCity"))){
this.cityname = res.data.data.data[i].cityName;
console.log("ccccc", this.cityname);
}
}
}
}).catch(err => {

})
}
},
methods: {
routerTo(){
this.$router.push("/posi?back=address")
},
backmethod(){
setTimeout(()=>{
history.go(-1);
},500)
}
},
beforeCreate(){
/*this.$http.post("/api?server=queryStationSite", {}).then(res => {
this.datac = res.data.data.data
}).catch(err => {

})*/
},
mounted() {
this.cityname = this.jbStorage&&this.jbStorage.cityName || "成都"
if(this.jbStorage&&this.jbStorage.city){
this.cityname = localStorage.getItem('jbStorage')&&JSON.parse(localStorage.getItem('jbStorage')).city.name
}
var me = this;
window.addEventListener('touchstart',function () {
if(me.$refs.inputs){
me.$refs.inputs.blur()
}
})
},
components: {
pkHeader,
station
}
}




// WEBPACK FOOTER //
// ./src/components/common/address.vue